/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyletypo3Inputs */

const en_aiflowstyletypo3 = /** @type {(inputs: Aiflowstyletypo3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettering`)
};

const de_aiflowstyletypo3 = /** @type {(inputs: Aiflowstyletypo3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schrift`)
};

/**
* | output |
* | --- |
* | "Lettering" |
*
* @param {Aiflowstyletypo3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyletypo3 = /** @type {((inputs?: Aiflowstyletypo3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyletypo3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyletypo3(inputs)
	return de_aiflowstyletypo3(inputs)
});
export { aiflowstyletypo3 as "aiFlowStyleTypo" }